/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import {observer} from "mobx-react";
import {makeApi, URLS} from "Utils/apiURL";

const SalesForceOauth = () => {
  const [connectSuccess, setConnectSuccess] = useState(false);

  const getAuthCode = () => {
    try {
      const url = new URL(window.location.href);
      return url.searchParams.get("code");
    } catch (e) {
      return null;
    }
  };

  const closeWindow = () => {
    try {
      window.close();
    } catch (e) {
      console.error("Window close error", e);
    }
  };

  const connectSalesForceApp = async () => {
    const code = getAuthCode();
    try {
      if (code) {
        const config = {
          url: `${URLS.connectSalesForce}?code=${code}`,
          method: "POST"
        };
        const res = await makeApi(config);
        if (res) {
          const resCode = res?.data?.code?.toString() || "500";
          const messagePayload = {
            code: resCode,
            type: "SALESFORCE_CONNECT_APP",
            connectedCrm: res?.data?.connectedCrm
          };

          try {
            if (window.opener) {
              window.opener.postMessage(messagePayload, "*");
            }
          } catch (e) {
            console.error("postMessage error", e);
          }

          try {
            if (typeof BroadcastChannel !== "undefined") {
              const bc = new BroadcastChannel("crm_auth_conn");
              bc.postMessage(messagePayload);
              bc.close();
            }
          } catch (e) {
            console.error("BroadcastChannel error", e);
          }

          if (resCode === "200") {
            setConnectSuccess(true);
            setTimeout(() => {
              closeWindow();
            }, 1000);
          } else {
            closeWindow();
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    connectSalesForceApp();
  }, []);

  return (
    <div className="pageClass">
      <div className="pageCont">
        <div className="connectAppSection">
          {connectSuccess ? (
            <div>
              <span>Successfully Connected</span>
            </div>
          ) : (
            <div>
              <div>Please wait while we connect your Salesforce account</div>
              <div style={{marginTop: "10px"}}> Connecting.. </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default observer(SalesForceOauth);
export {SalesForceOauth};
